/* =========================================================
   RABESSA AYUBI — motion layer

   Rules this file obeys, because they are the difference between
   "expensive" and "busy":
     · one orchestrated arrival, then the page gets out of the way
     · nothing loops in the reader's peripheral vision
     · no scroll hijacking, no autoplay, no cursor takeover
     · every effect is skipped wholesale under prefers-reduced-motion
     · the page is fully usable if this file never loads at all
   ========================================================= */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(pointer: fine)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------
     1. THE OVERTURE
     Four colour panels lift away like a printing press finishing
     a run, then the hero assembles. Once per session only — the
     second page view should feel fast, not ceremonial.
     --------------------------------------------------------- */
  function overture() {
    var root = document.documentElement;
    var el = $("[data-overture]");
    var seen = false;
    try { seen = window.sessionStorage.getItem("rabessa_overture") === "1"; } catch (e) {}

    if (!el) { heroIn(0); return; }
    if (reduce || seen) { el.classList.add("is-done"); heroIn(0); return; }

    try { window.sessionStorage.setItem("rabessa_overture", "1"); } catch (e) {}
    root.classList.add("is-overture");

    var panels = $$("i", el);
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.classList.add("is-done");
      root.classList.remove("is-overture");
    }
    // hard safety net: whatever happens to the animation, the page unlocks
    window.setTimeout(finish, 1600);

    if (!("animate" in el)) { finish(); heroIn(0); return; }

    panels.forEach(function (p, i) {
      p.animate(
        [{ transform: "translateY(0)" }, { transform: "translateY(-101%)" }],
        { duration: 620, delay: 120 + i * 85, easing: "cubic-bezier(.7,0,.2,1)", fill: "forwards" }
      );
    });
    window.setTimeout(finish, 120 + panels.length * 85 + 640);
    heroIn(360);
  }

  /* ---------------------------------------------------------
     2. HERO ARRIVAL
     Headline words rise in sequence, the framed photo unmasks,
     the burst lands last with a single spring. One gesture.
     --------------------------------------------------------- */
  function heroIn(delay) {
    if (reduce) {
      $$("[data-word]").forEach(function (w) { w.style.opacity = 1; });
      var f0 = $("[data-hero-frame]"); if (f0) f0.style.clipPath = "none";
      var t0 = $("[data-hero-burst]"); if (t0) t0.style.opacity = 1;
      return;
    }
    if (!("animate" in document.createElement("div"))) {
      $$("[data-word]").forEach(function (w) { w.style.opacity = 1; });
      return;
    }

    var words = $$("[data-word]");
    words.forEach(function (w, i) {
      w.style.opacity = 0;
      w.animate(
        [{ transform: "translateY(0.5em) rotate(-1.5deg)", opacity: 0 },
         { transform: "none", opacity: 1 }],
        { duration: 720, delay: delay + 80 + i * 62, easing: "cubic-bezier(.16,1,.3,1)", fill: "forwards" }
      );
    });

    var frame = $("[data-hero-frame]");
    if (frame) {
      // the tilt is part of the design, so it has to survive the reveal —
      // "transform: none" here would quietly flatten the frame
      var tilt = getComputedStyle(frame).getPropertyValue("--tilt") || "-1.4deg";
      frame.animate(
        [{ clipPath: "inset(0 0 100% 0)", transform: "translateY(16px) rotate(" + tilt + ")" },
         { clipPath: "inset(0 0 0 0)", transform: "rotate(" + tilt + ")" }],
        { duration: 900, delay: delay + 140, easing: "cubic-bezier(.16,1,.3,1)", fill: "both" }
      );
    }

    var burst = $("[data-hero-burst]");
    if (burst) {
      burst.style.opacity = 0;
      burst.animate(
        [{ transform: "scale(.3) rotate(-30deg)", opacity: 0 },
         { transform: "scale(1.14) rotate(6deg)", opacity: 1, offset: .68 },
         { transform: "none", opacity: 1 }],
        { duration: 760, delay: delay + 620, easing: "cubic-bezier(.2,.9,.25,1.2)", fill: "forwards" }
      );
    }

    var strip = $("[data-hero-strip]");
    if (strip) {
      strip.animate(
        [{ transform: "translateX(-24px) rotate(-8deg)", opacity: 0 },
         { transform: "rotate(-3deg)", opacity: 1 }],
        { duration: 640, delay: delay + 760, easing: "cubic-bezier(.2,.9,.25,1.2)", fill: "both" }
      );
    }
  }

  /* ---------------------------------------------------------
     3. BEN-DAY DOT FIELD
     A printed halftone that breathes, and swells slightly under
     the cursor. Ambient, never the main event. Pauses when the
     hero scrolls out of view so it costs nothing on a phone.
     --------------------------------------------------------- */
  function dotField() {
    var cv = $("#dots");
    if (!cv || !cv.getContext) return;
    var host = cv.parentNode;
    var ctx = cv.getContext("2d");
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, mx = -9999, my = -9999, t = 0, frame = 0;
    var color = "#FFC800";
    var running = true, raf = null;

    function readColor() {
      var v = getComputedStyle(document.documentElement).getPropertyValue("--dot").trim();
      if (v) color = v;
    }
    function resize() {
      var r = cv.getBoundingClientRect();
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      narrow = W < 760;
      readColor();
    }

    var STEP = 22;
    var narrow = false;
    function draw() {
      raf = null;
      if (!running) return;
      frame++;
      if (frame % 90 === 0) readColor();
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = color;
      if (!reduce) t += 0.011;

      for (var y = STEP / 2; y < H + STEP; y += STEP) {
        for (var x = STEP / 2; x < W + STEP; x += STEP) {
          // Dots stay small under the copy column and open up toward the
          // image side, so the headline never fights the halftone.
          // On phones the copy spans the full width, so the field flattens
          // out instead of ramping toward one side.
          var g = narrow
            ? 0.42 - (y / (H || 1)) * 0.12
            : 0.28 + (x / (W || 1)) * 0.95 - (y / (H || 1)) * 0.18;
          var wave = reduce ? 0 : Math.sin(x * 0.017 + y * 0.02 + t * 2) * 0.85;
          var r = g * 4.0 + wave;
          var dx = x - mx, dy = y - my, d2 = dx * dx + dy * dy;
          if (d2 < 26000) r += (1 - Math.sqrt(d2) / 161) * 5;
          if (r > 0.35) {
            ctx.beginPath();
            ctx.arc(x, y, Math.min(r, STEP / 2 - 1), 0, 6.2832);
            ctx.fill();
          }
        }
      }
      if (!reduce) raf = window.requestAnimationFrame(draw);
    }
    function kick() { if (!raf && running) raf = window.requestAnimationFrame(draw); }

    if (finePointer) {
      host.addEventListener("pointermove", function (e) {
        var r = cv.getBoundingClientRect();
        mx = e.clientX - r.left; my = e.clientY - r.top;
        if (reduce) return;
        kick();
      });
      host.addEventListener("pointerleave", function () { mx = -9999; my = -9999; });
    }

    window.addEventListener("resize", function () { resize(); kick(); });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        running = entries[0].isIntersecting;
        if (running) kick();
      }, { threshold: 0 }).observe(host);
    }

    resize();
    kick();
  }

  /* ---------------------------------------------------------
     4. MAGNETIC PRIMARY BUTTONS
     A few pixels of pull toward the cursor. Mouse only, and only
     on the buttons that matter — it reads as craft, not gimmick.
     --------------------------------------------------------- */
  function magnetic() {
    if (reduce || !finePointer) return;
    $$(".btn--primary").forEach(function (btn) {
      var raf = null, tx = 0, ty = 0;
      function apply() {
        raf = null;
        btn.style.transform = "translate(" + tx + "px," + ty + "px)";
      }
      btn.addEventListener("pointermove", function (e) {
        var r = btn.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 9;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 7;
        if (!raf) raf = window.requestAnimationFrame(apply);
      });
      btn.addEventListener("pointerleave", function () { btn.style.transform = ""; });
      btn.addEventListener("blur", function () { btn.style.transform = ""; });
    });
  }

  /* ---------------------------------------------------------
     5. POW — a single comic burst when something lands in the bag
     --------------------------------------------------------- */
  var POW_WORDS = ["POW!", "ZAP!", "BAM!", "YES!"];
  var powCount = 0;
  function pow() {
    if (reduce) return;
    var anchor = $("[data-drawer-open]");
    if (!anchor) return;
    var r = anchor.getBoundingClientRect();
    var word = POW_WORDS[powCount++ % POW_WORDS.length];
    var el = document.createElement("div");
    el.className = "pow";
    el.setAttribute("aria-hidden", "true");
    el.style.left = (r.left + r.width / 2) + "px";
    el.style.top = (r.top + r.height / 2) + "px";
    el.innerHTML =
      '<svg viewBox="0 0 100 100" width="150" height="150">' +
      '<polygon points="50,2 58,20 76,10 75,29 94,28 84,44 99,55 81,63 88,82 69,79 65,98 50,86 35,98 31,79 12,82 19,63 1,55 16,44 6,28 25,29 24,10 42,20" ' +
      'fill="#FFC800" stroke="#0E0C0A" stroke-width="4" stroke-linejoin="round"/>' +
      '<text x="50" y="59" text-anchor="middle" font-family="Luckiest Guy, Comic Sans MS, sans-serif" font-size="21" fill="#0E0C0A">' + word + "</text>" +
      "</svg>";
    document.body.appendChild(el);
    window.setTimeout(function () { el.remove(); }, 700);
  }

  function bumpCount() {
    $$("[data-cart-count]").forEach(function (n) {
      n.classList.remove("is-bumped");
      void n.offsetWidth;
      n.classList.add("is-bumped");
      window.setTimeout(function () { n.classList.remove("is-bumped"); }, 320);
    });
  }

  /* ---------------------------------------------------------
     6. HEADLINE WORD SPLITTING
     Done in JS so the markup stays one clean sentence for
     screen readers and search engines.
     --------------------------------------------------------- */
  function splitWords() {
    $$("[data-words]").forEach(function (el) {
      if (el.getAttribute("data-split") === "done") return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        if (!node.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
          var s = document.createElement("span");
          s.setAttribute("data-word", "");
          s.textContent = part;
          frag.appendChild(s);
        });
        node.parentNode.replaceChild(frag, node);
      });
      el.setAttribute("data-split", "done");
    });
  }

  /* ---------------------------------------------------------
     7. HERO VIDEO
     Silent and looping by design. Anyone who has asked their device
     to reduce motion gets a still frame with controls instead, so
     the clip is available but never moves on its own.
     --------------------------------------------------------- */
  function heroVideo() {
    var v = $("[data-hero-video]") || $(".hero__frame video");
    if (!v) return;
    v.muted = true;              // belt and braces: never make noise at a visitor
    v.setAttribute("playsinline", "");
    if (reduce) {
      v.autoplay = false;
      v.removeAttribute("autoplay");
      v.controls = true;
      try { v.pause(); } catch (e) {}
      return;
    }
    // Don't burn battery decoding a clip nobody is looking at.
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { try { v.pause(); } catch (err) {} }
        });
      }, { threshold: 0.1 }).observe(v);
    }
  }

  /* ---------------------------------------------------------
     8. PLATE REGISTRATION
     The brand cover opens like a misprinted poster and the colour
     plates slide into register. Runs once, on arrival.
     --------------------------------------------------------- */
  function plates() {
    var wrap = $("[data-plates]");
    if (!wrap || reduce || !("animate" in wrap)) return;
    $$(".brand__plate", wrap).forEach(function (p, i) {
      p.animate(
        [{ transform: "translate(" + (28 - i * 26) + "px," + (-18 + i * 16) + "px) scale(1.14)", opacity: 0 },
         { transform: "none", opacity: getComputedStyle(p).opacity }],
        { duration: 900, delay: 180 + i * 110, easing: "cubic-bezier(.16,1,.3,1)", fill: "both" }
      );
    });
  }

  /* ---------------------------------------------------------
     9. WORD ROTATOR
     Swaps the last word of one sentence. Paused whenever the line
     is off screen or the tab is hidden, so it is never animating
     somewhere nobody is looking. Under reduced motion the first
     word simply stays put and the sentence still reads.
     --------------------------------------------------------- */
  function rotator() {
    $$("[data-rotator]").forEach(function (rot) {
      var items = $$(".brand__rot", rot);
      if (items.length < 2 || reduce) return;

      var i = 0, timer = null, visible = false;

      function step() {
        items[i].removeAttribute("data-on");
        i = (i + 1) % items.length;
        items[i].setAttribute("data-on", "");
      }
      function start() { if (!timer) timer = window.setInterval(step, 2200); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function sync() { if (visible && !document.hidden) start(); else stop(); }

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.5 }).observe(rot);
      } else {
        visible = true;
        sync();
      }
      document.addEventListener("visibilitychange", sync);
    });
  }

  /* ---------------------------------------------------------
     boot
     --------------------------------------------------------- */
  function init() {
    splitWords();
    overture();
    dotField();
    magnetic();
    heroVideo();
    plates();
    rotator();

    document.addEventListener("rabessa:add_to_cart", function () { pow(); bumpCount(); });
    document.addEventListener("rabessa:update_cart", bumpCount);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
